import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'replaceTotalRobustScoreTo',
  standalone: false
})
export class ReplaceTotalRobustScoreToPipe implements PipeTransform {
  transform(value: string, totalScore: string, robustScore: string): string {
    if (
      typeof value !== 'undefined' &&
      value !== null &&
      value.trim().length > 0
    ) {
      return value
        .replace('{{totalScore}}', totalScore)
        .replace('{{robustScore}}', robustScore);
    }
    return value;
  }
}
